import { queryClient } from "../../../app/ReactQueryWrapper";
import { QUERY_KEYS } from "../constants";

export const invalidatePreferenceData = () =>
  queryClient.invalidateQueries(QUERY_KEYS.GET_GENERAL_PREFERENCE_V2);
